module.exports = __webpack_public_path__ + "static/Jupyter_Notebook-af8bdaf29c7701f43a02580ae2e9954b.svg";